import { request } from "@/interface/helper";

export const login = {

  login: {
    // isCancel: true,
    // getList: (options) => request({ isCancel: true, method: 'get', url: '/hot-search/list', ...options }),
    login: (options) => request({ method: "post", url: "/staff/login.json", ...options }),
    register: (data) => request({ data, method: "post", url: "/staff/register.json" }),
    info: (data) => request({ data, method: "get", url: "/staff/info.json" }),
    pwdreset: (data) => request({ data, method: "post", url: "/staff/pwdReset.json" }),
    check: (data) => request({ data, method: "get", url: "/staff/exists.json" }),
    verify: (data) => request({ noDialog: true, data, method: "get", url: "/captcha/verify" }),
    sendCode: (data) => request({ data, method: "get", url: "/verifycode/send.json" }),
    checkCode: (data) =>
      request({ noDialog: true, data, method: "get", url: "/verifycode/check.json" }),
    logout: (data) => request({ data, method: "post", url: "/staff/logout.json" }),
    password: (data) => request({ data, method: "post", url: "/staff/password" }),
  },
};
